export const wsUri = 'wss://michata.us.cc/websocket/';
export const  res = {
    "data": {
        "token": "44a7deb1b7ff447792603085a37f0fa0",
        "expire_time": 1765871723,
        "customer_service": {
            "id": 1,
            "admin_id": 1,
            "name": "cesgi",
            "avatar": "https://michata.us.cc/assets/img/qrcode.png",
            "max_num": 1,
            "lasttime": 0,
            "status": "online"
        },
        "config": {
            "type": "shopro",
            "basic": {
                "last_customer_service": 1,
                "allocate": "random",
                "notice": "显示在用户端头部"
            },
            "system": {
                "is_ssl": 1,
                "ssl_type": "reverse_proxy",
                "ssl_cert": "/www/server/panel/vhost/cert/****/fullchain.pem",
                "ssl_key": "/www/server/panel/vhost/cert/****/privkey.pem",
                "gateway_port": 1819,
                "gateway_num": 2,
                "gateway_start_port": 2010,
                "business_worker_port": 2238,
                "business_worker_num": 4
            }
        },
        "fast_reply": [
            {
                "id": 3,
                "name": "发货问题",
                "content": "<span style=\"white-space:normal;\">亲，一般会在下完单两天之内进行发货，如遇双十一等节日最晚会在一周内发货的，请耐心等待</span>",
                "status": "normal",
                "weigh": 3,
                "createtime": 1608630165,
                "updatetime": 1608630165,
                "status_text": "Status normal"
            },
            {
                "id": 2,
                "name": "红包退回问题",
                "content": "亲，如果是双11的红包，因为只能当天使用，所以退款的时候，红包将不会退回",
                "status": "normal",
                "weigh": 2,
                "createtime": 1608630134,
                "updatetime": 1608630134,
                "status_text": "Status normal"
            },
            {
                "id": 1,
                "name": "退款退回问题",
                "content": "亲，钱款都是按照原支付路径进行退回的，一般会在1~3三个工作日内完成退款，请注意查收",
                "status": "normal",
                "weigh": 1,
                "createtime": 1608629981,
                "updatetime": 1608629981,
                "status_text": "Status normal"
            }
        ],
        "emoji": [
            {
                "name": "[笑掉牙]",
                "file": "xiaodiaoya.png"
            },
            {
                "name": "[可爱]",
                "file": "keai.png"
            },
            {
                "name": "[冷酷]",
                "file": "lengku.png"
            },
            {
                "name": "[闭嘴]",
                "file": "bizui.png"
            },
            {
                "name": "[生气]",
                "file": "shengqi.png"
            },
            {
                "name": "[惊恐]",
                "file": "jingkong.png"
            },
            {
                "name": "[瞌睡]",
                "file": "keshui.png"
            },
            {
                "name": "[大笑]",
                "file": "daxiao.png"
            },
            {
                "name": "[爱心]",
                "file": "aixin.png"
            },
            {
                "name": "[坏笑]",
                "file": "huaixiao.png"
            },
            {
                "name": "[飞吻]",
                "file": "feiwen.png"
            },
            {
                "name": "[疑问]",
                "file": "yiwen.png"
            },
            {
                "name": "[开心]",
                "file": "kaixin.png"
            },
            {
                "name": "[发呆]",
                "file": "fadai.png"
            },
            {
                "name": "[流泪]",
                "file": "liulei.png"
            },
            {
                "name": "[汗颜]",
                "file": "hanyan.png"
            },
            {
                "name": "[惊悚]",
                "file": "jingshu.png"
            },
            {
                "name": "[困~]",
                "file": "kun.png"
            },
            {
                "name": "[心碎]",
                "file": "xinsui.png"
            },
            {
                "name": "[天使]",
                "file": "tianshi.png"
            },
            {
                "name": "[晕]",
                "file": "yun.png"
            },
            {
                "name": "[啊]",
                "file": "a.png"
            },
            {
                "name": "[愤怒]",
                "file": "fennu.png"
            },
            {
                "name": "[睡着]",
                "file": "shuizhuo.png"
            },
            {
                "name": "[面无表情]",
                "file": "mianwubiaoqing.png"
            },
            {
                "name": "[难过]",
                "file": "nanguo.png"
            },
            {
                "name": "[犯困]",
                "file": "fankun.png"
            },
            {
                "name": "[好吃]",
                "file": "haochi.png"
            },
            {
                "name": "[呕吐]",
                "file": "outu.png"
            },
            {
                "name": "[龇牙]",
                "file": "ziya.png"
            },
            {
                "name": "[懵比]",
                "file": "mengbi.png"
            },
            {
                "name": "[白眼]",
                "file": "baiyan.png"
            },
            {
                "name": "[饿死]",
                "file": "esi.png"
            },
            {
                "name": "[凶]",
                "file": "xiong.png"
            },
            {
                "name": "[感冒]",
                "file": "ganmao.png"
            },
            {
                "name": "[流汗]",
                "file": "liuhan.png"
            },
            {
                "name": "[笑哭]",
                "file": "xiaoku.png"
            },
            {
                "name": "[流口水]",
                "file": "liukoushui.png"
            },
            {
                "name": "[尴尬]",
                "file": "ganga.png"
            },
            {
                "name": "[惊讶]",
                "file": "jingya.png"
            },
            {
                "name": "[大惊]",
                "file": "dajing.png"
            },
            {
                "name": "[不好意思]",
                "file": "buhaoyisi.png"
            },
            {
                "name": "[大闹]",
                "file": "danao.png"
            },
            {
                "name": "[不可思议]",
                "file": "bukesiyi.png"
            },
            {
                "name": "[爱你]",
                "file": "aini.png"
            },
            {
                "name": "[红心]",
                "file": "hongxin.png"
            },
            {
                "name": "[点赞]",
                "file": "dianzan.png"
            },
            {
                "name": "[恶魔]",
                "file": "emo.png"
            }
        ]
    }
}